import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const VenueCardSkeleton = () => {
  return (
    <div className="h-full bg-white rounded-lg border border-zinc-400/50 p-2">
      <figure className="relative rounded-lg overflow-hidden">
        {/* For the image */}
        <Skeleton height={250} duration={1.2} enableAnimation />
      </figure>

      <div className="mt-1">
        {/* For the venue name */}
        <Skeleton count={1} height={30} duration={1.2} />
        {/* For the address */}
        <Skeleton count={1} height={20} width={`60%`} duration={1.2} />

        <div className="mt-3">
          {/* For additional information like opening hours */}
          <Skeleton count={1} height={20} width={`80%`} duration={1.2} />
          {/* For last updated info or warning message */}
          <Skeleton
            count={1}
            height={20}
            width={`50%`}
            duration={1.2}
            style={{ marginTop: "8px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default VenueCardSkeleton;
